import Backbone from 'backbone';

const ShipstationConnectData = {
  jobs: new Backbone.Collection(),
};

export default ShipstationConnectData;
